// NOTICE: KAPTION-INTEGRATION - Full-screen dashboard apps composable
// Shared between KaptionSidebar.vue and KaptionSidebarV2.vue
import { computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';

export function useFullScreenDashboardApps() {
  const store = useStore();
  const dashboardApps = useMapGetter('dashboardApps/getRecords');

  const fullScreenApps = computed(() =>
    dashboardApps.value.filter(app => app.is_full_screen)
  );

  function ensureLoaded() {
    if (dashboardApps.value.length === 0) {
      store.dispatch('dashboardApps/get');
    }
  }

  return { fullScreenApps, ensureLoaded };
}
